import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogActions } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ReactElement } from 'react';
import './Modal.scss';

interface ModalProps {
  open: boolean;
  onClose?: () => void;
  title: string;
  data: ReactElement;
  subtitle?: string;
  goBack?: () => void;
  button?: ReactElement;
  secondButton?: ReactElement;
  fullScreen?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
}

function Modal({
  open,
  onClose,
  title,
  subtitle,
  data,
  goBack,
  button,
  secondButton,
  fullScreen,
  fullWidth,
  disabled,
}: ModalProps) {
  const disabledStyle = {
    pointerEvents: 'none',
  };
  return (
    <Dialog
      onClose={onClose}
      open={open}
      className='dialog'
      fullScreen={fullScreen || false}
      fullWidth={fullWidth || false}
      disableEnforceFocus
    >
      <DialogTitle className='header'>
        <Box className='title'>
          {goBack && !disabled && <ArrowBackIcon onClick={goBack} />}
          {title}
        </Box>
        {!!onClose && <CloseIcon onClick={onClose} />}
      </DialogTitle>
      <DialogContent sx={disabled ? disabledStyle : {}}>
        <DialogContentText>{subtitle}</DialogContentText>
        {data}
      </DialogContent>
      <DialogActions
        sx={{
          p: 2,
          ...(disabled ? disabledStyle : {}),
        }}
      >
        {button} {secondButton}
      </DialogActions>
    </Dialog>
  );
}

export default Modal;
